import { useRef } from 'react';

const ESTIMATED_BUTTON_WIDTH = 150;
const TOOLBAR_BUTTON_GAP = 8;

export function useRequiredRecordingButtonWidth(width: number) {
    const maxWidthRef = useRef(width);

    if (width > maxWidthRef.current) {
        maxWidthRef.current = width;
    }

    const { current: maxWidth } = maxWidthRef;

    return (width || (maxWidth ? maxWidth : ESTIMATED_BUTTON_WIDTH)) + TOOLBAR_BUTTON_GAP;
}
